import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/home",
    name: "home",
    component: () => import("../views/home"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/login"),
    meta: {
      showLogin: true,
    },
  },
  {
    path: "/digital",
    name: "digital",
    component: () => import("../views/digital"),
    meta: {
      showLogin2: true,
    },
  },
  {
    path: "/excellent",
    name: "excellent",
    component: () => import("../views/excellent"),
    meta: {
      showLogin2: true,
    },
  },
  {
    path: "/ai",
    name: "ai",
    component: () => import("../views/ai"),
  },
  {
    path: "/copyright",
    name: "copyright",
    component: () => import("../views/copyright"),
    meta: {
      showLogin2: true,
    },
  },
  {
    path: "/copyright/details",
    name: "copyrightDetails",
    component: () => import("../views/copyright/details.vue"),
    meta: {
      showLogin2: true,
    },
  },
  {
    path: "/register",
    name: "register",
    component: () => import("../views/register"),
  },
  {
    path: "/creative",
    name: "creative",
    component: () => import("../views/creative"),
    meta: {
      showLogin2: true,
    },
  },
  {
    path: "/excellent/details",
    name: "excellentDetails",
    component: () => import("../views/excellent/details.vue"),
    meta: {
      showLogin2: true,
    },
  },
  {
    path: "/digital/details",
    name: "digitalDetails",
    component: () => import("../views/digital/details.vue"),
    meta: {
      showLogin2: true,
    },
  },
  {
    path: "/creative/details",
    name: "creativeDetails",
    component: () => import("../views/creative/details.vue"),
    meta: {
      showLogin2: true,
    },
  },
  {
    path: "/user",
    name: "user",
    component: () => import("../views/user"),
    meta: {
      showLogin2: true,
    },
  },
  {
    path: "/beCreator",
    name: "beCreator",
    component: () => import("../views/beCreator"),
    meta: {
      showLogin2: true,
    },
  },
];

const router = new VueRouter({
  routes,
});

// 配置路由守卫
router.beforeEach((to, from, next) => {
  //   if (to.path === "/login") {
  //     // 如果跳转的是登录页直接放行
  //     next();
  //   } else {
  //     // 跳转的不是登录页，需要判断是否有token
  //     // 从本地存储里获取token
  //     let token = localStorage.getItem("TOKEN");
  //     if (token === null || token === "") {
  //       // 不存在token，跳转到登录
  //       next({ path: "/login" });
  //     } else {
  //       // 存在则放行
  //       next();
  //     }
  //   }
  // console.log(to.path, from.path);
  // if (to.path == from.path) {
  //   return;
  // }
  document.body.scrollTop = 0; // firefox
  document.documentElement.scrollTop = 0; // safari
  window.pageYOffset = 0; // 调用 next()，一定要调用 next 方法，否则钩子就不会被销毁
  next();
});
export default router;
